import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import PhoneMockup from "@/components/site/PhoneMockup";
import ComingSoonButtons from "@/components/site/ComingSoonButtons";
import { APP_SHOT } from "@/lib/site";
import useSeo from "@/hooks/useSeo";

export default function Download() {
  useSeo({ title: "Download Orrbbit — Coming Soon", description: "Orrbbit is coming soon to iOS and Android. Explore how it works while we prepare to launch.", path: "/download" });
  return (
    <div data-testid="download-page">
      <section className="bg-lightbg">
        <div className="container-x grid grid-cols-1 items-center gap-12 section-space lg:grid-cols-2">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-orange shadow-soft">
              <span className="h-2 w-2 rounded-full bg-orange" /> Coming soon
            </span>
            <h1 className="mt-5 font-heading text-4xl font-bold tracking-tight text-navy md:text-5xl">Orrbbit is launching soon</h1>
            <p className="mt-5 max-w-xl text-lg text-bodygrey">We're putting the finishing touches on the Orrbbit apps for iOS and Android. The store links below will go live at launch.</p>
            <div className="mt-8"><ComingSoonButtons /></div><p className="mt-6 text-bodygrey">Already installed on your phone? <a className="font-semibold text-teal underline" href="orrbbit://login?type=personal">Open Orrbbit</a></p>
            <p className="mt-6 text-sm text-bodygrey">Want to learn more in the meantime?{" "}
              <Link to="/how-it-works" className="inline-flex items-center gap-1 font-semibold text-teal hover:underline">See how it works <ArrowRight size={15} /></Link>
            </p>
          </Reveal>
          <Reveal delay={0.1} className="flex justify-center">
            <PhoneMockup src={APP_SHOT} alt="Preview of the Orrbbit app" />
          </Reveal>
        </div>
      </section>
    </div>
  );
}

